// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1BZHm","title":"Images45_title__XceGv","images":"Images45_images__2vQz9"};